module.exports = __webpack_public_path__ + "static/sport/bgi-h5.7c3694d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/bgi-h5.jpg
// module id = 1lWc
// module chunks = 0